var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcReportUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D8F4E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5407 26.0974C31.0257 26.495 31.3013 27.081 31.3013 27.7107V29.4919C31.3013 29.9511 30.9323 30.3201 30.4731 30.3201C30.011 30.3201 29.6391 29.9454 29.656 29.4974V27.7159C29.656 27.5855 29.5989 27.4638 29.499 27.3827C28.8135 26.8202 28.0539 26.2995 27.2673 25.8295C26.7489 25.5197 26.3041 25.2813 25.9553 25.1098C25.6303 24.9475 25.4265 24.62 25.4265 24.2599V21.7534C25.4265 21.4743 25.5645 21.2145 25.793 21.0674C25.8911 21.0011 25.9492 20.8919 25.9492 20.7773V18.1747C25.9492 17.3411 25.2709 16.6615 24.4359 16.6615H23.8757C23.0422 16.6615 22.3625 17.3397 22.3625 18.1747V20.7773C22.3625 20.895 22.4187 20.9997 22.5171 21.0664C22.7452 21.2187 22.8851 21.478 22.8851 21.7534V24.2599C22.8851 24.6219 22.6791 24.951 22.3551 25.1051C22.0075 25.2761 21.5628 25.5144 21.0444 25.8242C20.2579 26.2942 19.4984 26.8149 18.8118 27.3782C18.7129 27.4585 18.656 27.5799 18.656 27.7107V29.4919C18.656 29.951 18.2868 30.3201 17.8279 30.3201C17.3689 30.3201 17 29.951 17 29.4919V27.7107C17 27.0811 17.2755 26.4951 17.7597 26.0979C18.8739 25.1798 20.0973 24.4116 21.2239 23.8215V22.12C20.8887 21.7513 20.7013 21.2744 20.7013 20.7719V18.1693C20.7013 16.4231 22.1226 15 23.8705 15H24.4305C26.1765 15 27.6 16.4215 27.6 18.1693V20.7719C27.6 21.2742 27.4124 21.7512 27.0773 22.1199V23.8215C28.2034 24.4113 29.4271 25.1797 30.5407 26.0974Z",
    fill: "#03A65B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReportUser);
export default __webpack_public_path__ + "static/media/ic-report-user.efddd8dc.svg";
export { ForwardRef as ReactComponent };